export default function CreatePathwayController() {}
